import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { LoadingDialog } from "../../../../../_metronic/_partials/controls";


export function RegistrationDataLoadingDialog() {
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.registrationData.listLoading }),
    shallowEqual
  );

  return <LoadingDialog isLoading={isLoading} />;
}
